import React from "react";
import { Redirect, useHistory, Link } from "react-router-dom";

function Success() {
    const token = localStorage.getItem("successfulReservationToken");
    let history = useHistory();
    // const handleOnSubmit = () => {
    //     localStorage.removeItem("successfulReservationToken");
    //     history.push("/login");
    //     return <Redirect to="www.google.com" />;
    // }
    if (Boolean(token)) {
        return (
            <div className="success-body">
                <div className="card">
                    <div className="logo-wrapper">
                        <i className="checkmark">✓</i>
                    </div>
                    <h1 className="success-h1">Success</h1>
                    <p className="success-p">Verification Code has been sent to you Email</p>
                    <Link to="https://portal.delsu.edu.ng/">
                        <button className="success-btn" >ok</button>
                    </Link>
                </div>
            </div>
        )
    }
    else {
        return (
            <Redirect to="/form" />
        )
    }
}
export default Success;



